import Breadcrumb from '@/components/Breadcrumb';
import Hero2 from '@/components/Hero2';
import Paginations2 from '@/components/Paginations2';
import ContactHero from '@/components/ContactHero';

import React, { useState } from "react";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SeoHead from '@/components/SeoHead';
import classes from './styles.module.scss';

import { blog_helper } from "@/helpers/blog_helper";
import { Cookies } from '@/components';

const CustomHeader = ({ date, decreaseMonth, increaseMonth }) => (
  <div className="custom-header">
    <button onClick={decreaseMonth}>
      <img alt="nav left" src="/icons/calendar-arrow-left.png" />
    </button>
    <div className="title">{date.toLocaleString('en-US', { month: 'long', year: 'numeric' })}</div>
    <button onClick={increaseMonth}>
      <img alt="nav right" src="/icons/calendar-arrow-right.png" />
    </button>
  </div>
);


export default function EventPage({all_events}) {

  const [selectedDate, setSelectedDate] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());

  const isOutsideMonth = (date) => {
    const dateMonth = date.getMonth();
    return currentMonth !== dateMonth;
  };

  const handleMonthChange = (date) => {
    setCurrentMonth(date.getMonth());
  };

  const highlightDates = all_events.filter((event) => event.eventdate).map((obj) => obj.eventdate ? (new Date(obj.eventdate)) : null);

  const filteredEvents = selectedDate
  ? all_events.filter(
      (event) =>
        new Date(event.eventdate).getDate() === selectedDate.getDate() &&
        new Date(event.eventdate).getMonth() === selectedDate.getMonth() &&
        new Date(event.eventdate).getFullYear() === selectedDate.getFullYear()
    )
  : all_events;

  // const isOutsideMonth = (date) => {
  //   const currentMonth = new Date(selectedDate).getMonth();
  //   const dateMonth = date.getMonth();
  //   return currentMonth !== dateMonth;
  // };

   const image = {
    path: "event.contact_hero.image",
  };

  return (
    <>
      <div style={{padding: '200px 60px 0'}}>
        <SeoHead
            page_name={`Xcede Technology Recruitment Specialists | Events`}
            canonical_link={`https://www.xcede.com/events`}
          />
        <Breadcrumb label="Events" />
        <div style={{padding: '40px 0 100px'}}>
          <Hero2 highlight="Events" body="At Xcede, we host and attend events as a source of continuous learning and connection-building, helping us stay at the forefront of our field. Join us in shaping the future of all the technology sectors, one event at a time." readMore={false}></Hero2>
        </div>
      </div>
      <div className={classes.events}>
        <div className={classes.paginations}>
          <Paginations2 resources={filteredEvents} />
        </div>
        <div className={classes.filter}>
          <div className={classes.datePicker}>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              highlightDates={highlightDates}
              customInput={<input style={{ display: 'block' }} />}
              renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                <CustomHeader date={date} decreaseMonth={decreaseMonth} increaseMonth={increaseMonth} />
              )}
              formatWeekDay={nameOfDay => nameOfDay.substr(0,3)}
              calendarStartDay={1}
              dayClassName={(date) => (isOutsideMonth(date) ? 'outside-month' : '')}
              onMonthChange={handleMonthChange}
              inline
            />
          </div>
        </div>
      </div>
      <ContactHero image={image} title="Connect with Xcede!" description="If you are interested in co-hosting an event with Xcede or if you are an experienced professional who would like to share your insights as a guest speaker, get in touch with us today!" buttonLabel="Get in Touch" buttonLink="/contact-us"/>
      
    </>
  );
}

export async function getStaticProps({}) {
  const all_events = blog_helper.fetch().filter((resource) => resource.category?.toLowerCase() === 'events');

  return {
    props: {
      all_events
    },
  };
}
